import React from "react";
import { PosterHeader } from "./PosterHeader.jsx";
import { PosterImage } from "./PosterImage.jsx";
import { PosterTitle } from "./PosterTitle.jsx";
import { PosterMetadata } from "./PosterMetadata.jsx";
import { PosterIngredients } from "./PosterIngredients.jsx";
import { PosterFooter } from "./PosterFooter.jsx";
import { POSTER_PAD } from "../constants.js";

export function PosterCard({
  recipe,
  imgUrl,
  template,
  ingredients,
  userName,
}) {
  return (
    <div
      className="h-full flex flex-col min-h-0"
      style={{
        overflow: "hidden",
        padding: POSTER_PAD,
        boxSizing: "border-box",
      }}
    >
      <PosterHeader />
      <PosterImage imgUrl={imgUrl} alt={recipe?.title} />
      <div className="flex-1 min-h-0 flex flex-col gap-2 overflow-hidden">
        <PosterTitle title={recipe?.title} />
        <PosterMetadata recipe={recipe} />
        <PosterIngredients
          ingredients={ingredients}
          accentColor={template?.accent}
        />
      </div>
      <PosterFooter userName={userName} />
    </div>
  );
}
